import styled from 'styled-components';
import { StarOutlineIc } from '@dsch/dd-icons';

import { Button } from 'components/Toolkit/Button/Button';
import { media } from 'helpers/breakpoints';

interface ISaveSearchButtonProps {
  disabled?: boolean;
  onClick: () => void;
  className?: string;
}

const SButton = styled(Button)`
  ${media.large} {
    margin-bottom: ${({ theme }) => theme.spacing.M16};
  }
`;

const SaveIcon = styled(StarOutlineIc)<{ disabled?: boolean }>`
  color: ${({ theme, disabled }) =>
    disabled ? theme.colors.WHITE : theme.colors.ORANGE};
`;

function SaveSearchButton({
  disabled,
  onClick,
  className,
}: ISaveSearchButtonProps) {
  return (
    <SButton
      data-testid="save-search-button"
      disabled={disabled}
      icon={<SaveIcon disabled={disabled} />}
      onClick={onClick}
      ofType="SECONDARY"
      className={className}
    >
      Save Search
    </SButton>
  );
}

export { SaveSearchButton };
